export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://stegato-api.herokuapp.com/api';



// WEBPACK FOOTER //
// ./src/auth/config.js